var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-steps__container"},[_c('div',{staticClass:"text-center th-py-24"},[_c('header-logo',{attrs:{"height":"24","light":false}})],1),_c(_vm.sideMenuComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }